import React from 'react';

import BaseComponent from 'src/components/BaseComponent';
import { MCButton } from 'src/components/basic';
import { MediaDropProgressBox, popupModel } from 'src/components/complex';
import QRCode from 'src/components/basic/QRCode';
import { lang, remCss, withRouter } from 'src/helpers';

import model from './model';
import CertificateFiles from './CertificateFiles';
import UploadForm from './UploadForm';

class Certificate extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    model.on('openCertificateForm', this.open);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    model.cancel('openCertificateForm', this.open);
  }

  open = ({ file }) => {
    this.mediaRef.onDrop('certificateFiles', file);
  };

  render() {
    const createState = model.getApiState('update');
    const { loading, invalid } = createState;

    return (
      <div className={'mc-main-content'}>
        <form className={'mc-setting-question'}>
          <div className={'mc-header'}>
            <div className={'mc-title mc-grow mc-ptb8'}>{lang.t('Certificate')}</div>
            {model.state.updating && (
              <MCButton
                primary
                medium
                dark
                radius
                disabled={loading}
                onClick={() =>
                  model.saveData((err) => {
                    !err && model.setState({ updating: false, updatingData: [] });
                  })
                }
              >
                {loading ? lang.t('Saving') + '...' : lang.t('Save Updates')}
              </MCButton>
            )}
          </div>
          <div className={'mc-flex-25-col mc-p30'} style={{ overflow: 'auto', height: '100%' }}>
            <MediaDropProgressBox
              ref={(r) => (this.mediaRef = r)}
              name={'certificateFiles'}
              multi={false}
              beforeUpload={(files, upload) => {
                popupModel.setActivePopup('certificate', {
                  active: true,
                  component: UploadForm,
                  props: { files, upload }
                });
              }}
              onUpload={(file, cbProgress, cb) => model.saveData(cb, cbProgress, file)}
              accept={{
                'image/*': [],
                'application/pdf': ['.pdf']
              }}
            />
            <CertificateFiles
              certificateFiles={model.state.certificateFiles}
              invalid={invalid?.certificateFiles}
            />
            <QRCode action='cert' handoff={true} size={remCss(256)} className='mc-qr-section mc-mb20'>
              <div className='mc-mt10 mc-qr-description'>
                {lang.t('Scan to upload from mobile')}
              </div>
            </QRCode>
          </div>
        </form>
      </div>
    );
  }
}

export default withRouter(Certificate);
